import { connect } from "react-redux";

export const ExportsLoadingMessage = ({ display, loadingMessage }) => {
  return (
    <div className="loadingMessage">
      <h1>
        {loadingMessage ? (
          <span className="secondary">
            <i className="icon-spinner-alt icon-spin" />
            {loadingMessage} . . .
          </span>
        ) : (
          <span>
            <i className="icon-search" />
            {display}
          </span>
        )}
      </h1>
    </div>
  );
};

export const displayLoadingText = ({ cases }) => {
  const sBuild = (type, count) => `${count} ${type}${count === 1 ? "" : "s"} `;
  const typeLength = cases.length;
  let disp = sBuild("case", typeLength);
  return disp.concat(" displayed");
};

const mapStateToProps = (state) => ({
  display: displayLoadingText({
    cases: state.cases,
  }),
  loadingMessage: state.loadingMessage,
});

const ConnectedExportLoadingMessage = connect(mapStateToProps)(
  ExportsLoadingMessage
);

export default ConnectedExportLoadingMessage;
